var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    className: "thumb-none-symbol",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("line", {
    className: "line",
    y1: "100%",
    x2: "100%"
  }));
};